// extracted by mini-css-extract-plugin
export var link = "_qf-0";